import { SLAProps } from "../src/sla/shared/types";

window.EasyVue ||= {};

window.EasyVue.initSLA = async (appWrapperId: string, props: SLAProps) => {
  const { initSLA } = await import("../src/sla/main");
  window.EasyVue.initSLA = initSLA;
  initSLA(appWrapperId, props);
};
